const SimpleAddIcon = () => {
  return (
    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.66626 7.00391H13.3364" stroke="#1062D0" strokeWidth="2" stroke-linecap="round" />
      <path d="M7.50073 1.16797V12.8381" stroke="#1062D0" strokeWidth="2" stroke-linecap="round" />
    </svg>
  );
};

export default SimpleAddIcon;
